import {
  CUSTOM_ELEMENTS_SCHEMA,
  ChangeDetectionStrategy,
  Component,
  Input,
  inject,
} from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { SwiperOptions } from 'swiper/types';

import {
  Product,
  ProductionService,
  SwiperDirective,
  TranslateDirective,
} from '@speedy/core';
import { ProductListItemComponent } from '../product-list-item/product-list-item.component';
import { SlicePipe } from '@angular/common';

@Component({
  standalone: true,
  selector: 'app-products-slider',
  templateUrl: './products-slider.component.html',
  styleUrls: ['./products-slider.component.scss'],
  imports: [
    ProductListItemComponent,
    MatIconModule,
    TranslateDirective,
    SwiperDirective,
    SlicePipe,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class ProductsSliderComponent {
  private readonly productionService = inject(ProductionService);

  @Input() className!: string;
  @Input() title!: string;
  @Input() products!: Product[];
  @Input() sliderConfig!: SwiperOptions;

  isServer() {
    return this.productionService.isServerMode();
  }
}
